import { getResponseParseService } from 'services/ResponseParseService'
import { makeSpinRequest } from 'services/ServerService'
import { signal } from 'services/SignalsService'

const name = 'REQUEST-SPIN'

async function execute() {
  signal.dispatch(`SOUND:spin-btn:${game.models.ModeModel.turbo}`)

  const lines = game.models.SpinModel.get().lines
  const multiplier = game.models.SpinModel.get().buy[0]
  const action = 'buy'
  const response = await makeRequest({
    action: action,
    token: game.models.GameModel.token,
    params: {
      bet: game.models.BetModel.getValue() / lines,
      lines,
      multiplier,
    },
    platform: game.models.GameModel.platform,
    m: game.models.GameModel.m,

  })
  getResponseParseService().parse(response)
}

function makeRequest(data) {
  return makeSpinRequest(data)
}

export function getRequestBuyAction() {
  return {
    name,
    execute,
  }
}
